import React, { useState, useEffect, useRef } from "react";
import "./musicList.css";
import * as T from "../../type";
import ReactSlider from "react-slider";
import { Pause, Play } from "./import";
import Equalizer from "../Equalizer/equalizer";
import { Link, useLocation } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { postUserCountApi } from "../../Api/baseApi";
import data from "./data";

const DEFAULT_ALBUM = "/imgs/etc/defualt_album.png";
export const isIOS = () => navigator.userAgent.toLowerCase().includes("mac");

const secToMin = (sec: number) => {
  const min = Math.floor(sec / 60);
  const restSec = sec % 60;

  return `${min}:${restSec < 10 ? "0" + restSec : restSec}`;
};

const Music = ({
  song,
  playingSong,
  playing,
  ontogglePlaySong,
}: {
  song: T.Song;
  playingSong: T.Song;
  playing: boolean;
  ontogglePlaySong: (song: T.Song) => void;
}) => {
  const isNowSong = song.music === playingSong.music;
  const isPlay = isNowSong && playing;

  return (
    <div
      onClick={() => ontogglePlaySong(song)}
      className={`flex h-28 backdrop-blur border items-center justify-between p-4 pr-14 ${
        isIOS() ? "mr-5" : "mr-32"
      }  bg-white cursor-pointer
      ${
        isNowSong
          ? "bg-opacity-[0.36]  border-white"
          : "bg-opacity-[0.16] border-[rgba(255,255,255,0.16)]"
      }
       rounded-2xl`}
      style={{
        boxShadow: "0px 4px 35px 0px rgba(0, 0, 0, 0.16)",
        backdropFilter: "blur(40px)",
      }}
    >
      <div className="flex items-center min-w-0">
        <img
          className="object-cover w-20 h-20 rounded-xl"
          src={song.thumbnail}
          alt=""
        />
        <div className="min-w-0 text-left mx-9">
          <h4 className="mb-2 text-2xl text-white ell semi-bold">
            {song.title}
          </h4>
          <span
            className={`ell regular text-lg text-white ${
              !isNowSong && "opacity-80"
            }`}
          >
            {song.artist_name}
          </span>
        </div>
      </div>
      <div className="flex items-center">
        <span
          className={`ell regular text-lg ${
            isNowSong ? "text-white" : "text-[#e2e2e2]"
          }`}
        >
          {secToMin(song.duration)}
        </span>
        <Equalizer isPlay={isPlay} />
        <button>{isPlay ? <Pause /> : <Play />}</button>
      </div>
    </div>
  );
};

export const MusicList = () => {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [link, setLink] = useState("");
  const [imgUrl, setImgUrl] = useState("");

  const songs = useRef<T.Song[]>([]);
  const audio = useRef<HTMLAudioElement>(null);
  const recordRef = useRef<HTMLDivElement>(null);
  const playingSong = useRef({} as T.Song);

  const setPlayingSong = (song: T.Song) => (playingSong.current = song);

  const duration = () => audio.current?.duration || 0;
  const currentTime = () => audio.current?.currentTime || 0;
  const percent = () => (currentTime() / duration()) * 100;

  const loaction = useLocation();

  const get20 = (musicList: T.Song[], ran: number) => {
    const start = ran % (musicList.length - 20) || 0;
    const list = musicList.slice(start, start + 20);
    return list;
  };

  useEffect(() => {
    const ran = Math.floor(Math.random() * 1000 + 1000);
    // postUserCountApi();
    setInterval(() => {
      if (audio.current?.currentTime) setProgress(percent());
    }, 100);
    const { imgUrl, musicList, stationIdx } = loaction.state || {
      imgUrl: "",
      musicList: data,
      stationIdx: 1200211,
    };
    setImgUrl(imgUrl);
    const list = get20(musicList, ran);
    songs.current = list;
    const date = Date.now();
    setLink(
      `https://ces.indj.ai/qrmusiclist/${stationIdx}?image=${
        imgUrl || ""
      }&date=${date}&start=${ran}`,
    );
    ontogglePlaySong(songs.current[0]);
  }, []);

  const getNowSongIdx = () =>
    songs.current.findIndex((el) => el.song_id === playingSong.current.song_id);

  const play = () => {
    const $audio = audio.current;
    if ($audio === null) return;

    setPlaying(true);
    $audio.play();

    $audio.onended = () => {
      if (getNowSongIdx() + 1 === songs.current.length) {
        setPlaying(false);
      }

      playNextSong();
    };
  };

  const slideRecord = () => {
    const X_SLIDE = "x-slide";
    const el = recordRef.current;

    if (el?.classList.contains(X_SLIDE)) return;
    el?.classList.add(X_SLIDE);

    setTimeout(() => {
      el?.classList.remove(X_SLIDE);
    }, 1000);
  };

  const pause = () => {
    const $audio = audio.current;
    if ($audio === null) return;
    $audio.pause();
    setPlaying(false);
  };
  const ontogglePlaySong = (song: T.Song = playingSong.current) => {
    const $audio = audio.current;
    if ($audio === null) return;

    if (playingSong.current.music === song.music) {
      playing ? pause() : play();
    } else {
      slideRecord();
      setPlayingSong(song);
      $audio.src = song.music;
      play();
    }
  };

  // 다음곡 재생
  const playNextSong = () => {
    const nowSongIdx = getNowSongIdx();
    if (nowSongIdx + 1 === songs.current.length) {
      ontogglePlaySong(songs.current[0]);
      return;
    }
    ontogglePlaySong(songs.current[getNowSongIdx() + 1]);
  };

  const playPrevSong = () => {
    const nowSongIdx = getNowSongIdx();
    if (nowSongIdx === 0) return;
    ontogglePlaySong(songs.current[nowSongIdx - 1]);
  };

  return (
    <div id="result" className="flex h-full p-5 pr-0 text-center">
      <div className="relative w-1/2">
        <div className="absolute flex flex-col items-center justify-center w-full p-center">
          <div className="relative flex items-center justify-center w-full h-[370px]">
            <img
              src={playingSong.current.thumbnail || DEFAULT_ALBUM}
              alt={playingSong.current.title || "앨범커"}
              style={{
                boxShadow:
                  "5px 5px 10px rgba(0, 0, 0, 0.2),-5px -5px 10px rgba(0, 0, 0, 0.2), 10px -5px 10px rgba(0, 0, 0, 0.2), -5px 5px 10px rgba(0, 0, 0, 0.2)",
              }}
              className=" relative z-10 rounded-lg -translate-x-1/4 w-[346px] h-[346px]"
            />
            <div
              ref={recordRef}
              className="absolute transition-all cursor-pointer translate-x-1/4 hover:translate-x-3/4"
            >
              <div
                style={{
                  backgroundImage: "url(/imgs/album/record.png)",
                  animationPlayState: `${playing ? "running" : "paused"}`,
                }}
                className="relative object-cover bg-center rounded-full w-80 h-80 spin"
              >
                <div
                  style={{
                    backgroundImage: `url(${playingSong.current.thumbnail})`,
                  }}
                  className="absolute w-32 h-32 bg-center bg-cover rounded-full p-center"
                ></div>
              </div>
            </div>
          </div>
          <h2 className="w-4/5 mt-12 mb-16 text-5xl font-bold text-white ell leading-[160%]">
            {playingSong.current.title || "title"}
          </h2>
          <div className="w-[600px]">
            <ReactSlider
              className="slider"
              thumbClassName="thumb"
              trackClassName="track"
              renderThumb={(props, state) => <div {...props}></div>}
              value={progress}
              onChange={(clilkedPositionX) => {
                if (audio.current) {
                  audio.current.currentTime =
                    duration() * clilkedPositionX * 0.01;
                  play();
                }
              }}
              step={0.1}
            />
            <div className="flex justify-between mt-5 text-2xl text-white">
              <span>{secToMin(Math.floor(currentTime()))}</span>
              <span>{secToMin(Math.floor(duration()))}</span>
            </div>
          </div>
          <div className="flex mt-10">
            <button onClick={playPrevSong}>
              <img src="/imgs/etc/prev_song.png" alt="" />
            </button>
            <button onClick={() => ontogglePlaySong()} className="mx-20">
              <img
                className="w-24 h-24"
                src={`/imgs/etc/now_${playing ? "pause" : "play"}.png`}
                alt=""
              />
            </button>
            <button onClick={playNextSong}>
              <img src="/imgs/etc/next_song.png" alt="" />
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-1/2 p-5 pt-20 pr-3 ">
        <div className="flex items-center gap-8 text-left mb-7 pl-[10px]">
          {/* <QRCodeSVG
            bgColor="rgba(255,255,255,0)"
            value={link}
            width={80}
            imageSettings={{
              src: "/imgs/etc/icon_logo.png",
              height: 20,
              width: 20,
              excavate: true,
            }}
          /> */}
          <div>
            <h1 className="text-5xl font-bold leading-snug text-white">
              당신을 위한 뮤직 스테이션
            </h1>
          </div>
        </div>
        <div
          className={`flex flex-col h-[60vh] gap-5 overflow-auto scroll p-[10px] rounded-[10px] ${
            isIOS() && "w-4/5"
          }`}
        >
          {songs.current.map((song, idx) => {
            return (
              <Music
                song={song}
                ontogglePlaySong={ontogglePlaySong}
                playing={playing}
                playingSong={playingSong.current}
                key={idx}
              />
            );
          })}
        </div>
        <Link to="/">
          <img className="w-56 ml-64 mt-14" src="/imgs/etc/reTry.png" alt="" />
        </Link>
        <div className="flex justify-end gap-4 text-xl font-bold text-white">
          <img className="" src="/imgs/etc/tele.png" alt="" />
          제품 문의 070 - 7779 - 0733
        </div>
      </div>
      <audio crossOrigin="anonymous" ref={audio}>
        <source src={playingSong.current.music} />
      </audio>
    </div>
  );
};
